// extracted by mini-css-extract-plugin
export default {"saveButton":"SaveMoneyButton-module__saveButton__UTAOB"};